export default __webpack_public_path__ + "static/media/Camion8-t.6c161c64.png";